import { ImageSizeTokens, AspectRatioToken, PaddingSizeTokens, } from '@voltmoney/schema';
export const imageTypeTokensMap = {
    [ImageSizeTokens.SIZE_16]: 16,
    [ImageSizeTokens.XXS]: 20,
    [ImageSizeTokens.SIZE_22]: 20,
    [ImageSizeTokens.XS]: 24,
    [ImageSizeTokens.SIZE_32]: 32,
    [ImageSizeTokens.SM]: 36,
    [ImageSizeTokens.SIZE_40]: 40,
    [ImageSizeTokens.MD]: 48,
    [ImageSizeTokens.SIZE_42]: 42,
    [ImageSizeTokens.SIZE_46]: 46,
    [ImageSizeTokens.SIZE_52]: 52,
    [ImageSizeTokens.SIZE_56]: 56,
    [ImageSizeTokens.Size_60]: 60,
    [ImageSizeTokens.SIZE_64]: 64,
    [ImageSizeTokens.LG]: 72,
    [ImageSizeTokens.XL]: 96,
    [ImageSizeTokens.XXL]: 128,
    [ImageSizeTokens.XXXL]: 180,
    [ImageSizeTokens.XXXXL]: 280,
    [ImageSizeTokens.Size_40]: 40,
    [ImageSizeTokens.SIZE_304]: 304,
    [ImageSizeTokens.Size_330]: 330,
    [ImageSizeTokens.Size_364]: 364,
    [ImageSizeTokens.Size_380]: 380,
    [ImageSizeTokens.FULL]: '100%',
};
export const paddingTypeTokensMap = {
    [PaddingSizeTokens.NONE]: 0,
    [PaddingSizeTokens.XS]: 2,
    [PaddingSizeTokens.SM]: 4,
    [PaddingSizeTokens.MD]: 6,
    [PaddingSizeTokens.LG]: 8,
    [PaddingSizeTokens.XL]: 10,
    [PaddingSizeTokens.XXL]: 15,
    [PaddingSizeTokens.XXXL]: 20,
};
export const aspectRationTokensMap = {
    [AspectRatioToken.A1_1]: 1,
    [AspectRatioToken.A2_1]: 2,
    [AspectRatioToken.A4_3]: 4 / 3,
    [AspectRatioToken.A3_4]: 3 / 4,
    [AspectRatioToken.A16_9]: 16 / 9,
    [AspectRatioToken.A9_16]: 9 / 16,
};
